export function loadScriptPromise(src: string, id = '') {
  return new Promise((resolve, reject) => {
    let script = document.getElementById(id) as HTMLScriptElement | null

    if (!script) {
      script = document.createElement('script')
      script.src = src
      script.id = id
      script.async = true
    }

    if (script.getAttribute('data-load-state') === 'loaded') {
      return resolve(null)
    }

    if (script.getAttribute('data-load-state') === 'error') {
      return reject(null)
    }

    const onLoad = () => {
      script?.setAttribute('data-load-state', 'loaded')
      resolve(null)

      script?.removeEventListener('load', onLoad)
    }

    const onError = () => {
      script?.setAttribute('data-load-state', 'error')
      reject(event)

      script?.removeEventListener('error', onError)
    }

    script.addEventListener('load', onLoad)
    script.addEventListener('error', onError)

    if (!document.getElementById(id)) {
      document.body.appendChild(script)
    }
  })
}
